import { Modal, Form, Input, Button, Select } from "antd";
import { useEffect } from "react";
import { ACTION, RESOURCE } from "../../constants/common";
import {
  useCreatePermission,
  useUpdatePermission,
} from "../../query/PermissionQuery";
import { ICreatePermission } from "../../models/Permission";
import { notify } from "../../utils/toast";

interface PermissionChild {
  key: string;
  title: string;
  description?: string;
  action?: string;
  resource?: string;
  permissionCode?: string;
}

interface ModalActionPermissionProps {
  open: boolean;
  permission: PermissionChild | null;
  onCancel: () => void;
}

const ModalActionPermission = ({
  open,
  permission,
  onCancel,
}: ModalActionPermissionProps) => {
  const [form] = Form.useForm();
  const isEdit = !!permission;
  const createPermission = useCreatePermission();
  const updatePermission = useUpdatePermission();
  useEffect(() => {
    if (open && permission) {
      form.setFieldsValue(permission);
    } else {
      form.resetFields();
    }
  }, [open, permission, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const data: ICreatePermission = {
        description: values.description,
        permissionCode: values.permissionCode,
        permissionName: values.title,
        action: values.action,
        resource: values.resource,
      };
      if (!isEdit) {
        await createPermission.mutateAsync(data);
        notify.success("Tạo quyền thành công");
        onCancel();
      } else {
        const permissionId = permission?.key.split("-")[1];

        const updateData = {
          ...data,
          id: Number(permissionId),
        };
        await updatePermission.mutateAsync(updateData);
        notify.success("Cập nhật quyền thành công");
        onCancel();
      }
    } catch (error) {
      notify.error("Vui lòng điền đẩy đủ thông tin");
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={isEdit ? "Chỉnh sửa quyền" : "Tạo quyền mới"}
      width={600}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Hủy
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={createPermission.isPending || createPermission.isPending}
          onClick={handleSubmit}
        >
          {isEdit ? "Cập nhật" : "Tạo"}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" className="mt-4">
        <Form.Item
          label="Mã quyền"
          name="permissionCode"
          rules={[{ required: true, message: "Vui lòng nhập mã quyền" }]}
        >
          <Input placeholder="VD: WAREHOUSE_CREATE" />
        </Form.Item>
        <Form.Item
          label="Tên quyền"
          name="title"
          rules={[{ required: true, message: "Vui lòng nhập tên quyền" }]}
        >
          <Input placeholder="VD: Tạo kho" />
        </Form.Item>
        <Form.Item label="Mô tả" name="description">
          <Input.TextArea placeholder="Mô tả chi tiết quyền" rows={3} />
        </Form.Item>
        <Form.Item
          label="Hành động"
          name="action"
          required
          rules={[{ required: true, message: "Vui lòng chọn hành động" }]}
        >
          <Select placeholder="VD: CREATE">
            {ACTION.map((item) => (
              <Select.Option key={item.name} value={item.value}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Tài nguyên"
          name="resource"
          required
          rules={[{ required: true, message: "Vui lòng chọn tài nguyên" }]}
        >
          <Select placeholder="VD: WAREHOUSE">
            {RESOURCE.map((item) => (
              <Select.Option key={item.name} value={item.value}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalActionPermission;
